.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4.8rem 3.2rem 2.4rem;
  max-width: 47.6rem;
  text-align: center;
}

.icon {
  position: relative;
  height: 9.6rem;
  width: 9.6rem;
  border: 0.2rem solid var(--color-error);
  background: var(--color-error-20);
  border-radius: 50%;
  margin-bottom: 3.2rem;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--color-error);
    height: 3.6rem;
    width: 3.6rem;
  }
}

.title {
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 400;
  margin-bottom: 0.8rem;
}

.description {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 300;
}
